import { render } from "./QuickLinks.vue?vue&type=template&id=58a039fc"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"

import "./QuickLinks.vue?vue&type=style&index=0&id=58a039fc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QuickLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58a039fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58a039fc', __exports__)) {
    api.reload('58a039fc', __exports__)
  }
  
  module.hot.accept("./QuickLinks.vue?vue&type=template&id=58a039fc", () => {
    api.rerender('58a039fc', render)
  })

}


export default __exports__